<template lang="html">
  <div
    :style="{
      'align-items':msAlign,
      'justify-content':msJustify,
      'display':msType,
      'overflow': msType === 'block' ? 'hidden' : null,
      'width': getWidth,
      'height': height,
      'line-height': getLineHeight,
      'text-indent': textIndent + 'px',
      'padding': padding + 'px',
      'text-indent': textIndent + 'px',
      'margin-bottom': msMb}"
    class="ms-row">
    <slot/>
  </div>
</template>

<script>
  export default {
    name: 'MsRow',
    props: {
      msType: {
        default: 'flex',
        type: String,
      },
      msW: {
        type: [Number, String],
        default: 12,
      },
      msJustify: {
        type: String,
        default: null,
      },
      msAlign: {
        type: String,
        default: null,
      },
      msMb:{
        type: String,
        default : "16px"
      },
      height: {
        type: [Number, String],
      },
      lineHeight: {
        type: [Number, String],
        default: 35
      },
      textIndent: {
        type: [Number, String],
        default: 0,
      },
      padding: {
        type: [Number, String],
        default : "0"
      },
    },
    computed: {
      getWidth() {
        return this.msW*100/12+'%';
      },
      getLineHeight() {
        return !isNaN(this.lineHeight) ? this.lineHeight + 'px' : 'none';
      }
    }
  }
</script>

<style lang="scss">
  .ms-row {
    clear: both;
    flex-flow: wrap;
  }
</style>
